<template>
  <v-menu>
    <template #activator="{ isActive, props }">
      <v-btn
        v-bind="props"
        style="box-shadow: none;"
      >
        <icon-loader
          name="globe"
          :color="color"
        />
        &nbsp;
        {{ $i18next.resolvedLanguage.toUpperCase() }}
        <icon-loader
          name="trailing-icon"
          :color="color"
          :upside-down="isActive"
          class="mr-n6"
        />
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
        v-for="[lng, languageName] in Object.entries($i18next.options.languages)"
        :key="lng"
      >
        <v-list-item-title
          style="cursor: pointer;"
          @click="changeLanguage(lng)"
        >
          {{ languageName }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { useLocale } from "vuetify";
import i18next from "i18next";
import IconLoader from "../tools/IconLoader.vue";
const { color } = defineProps({
  color: {
    type: String,
    default: null
  }
});

const { current } = useLocale();

const changeLanguage = (lng) => {
  current.value = lng;
  i18next.changeLanguage(lng);
};
</script>
